// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPopup_container__3Dcm3","selector":"OrderPopup_selector__3IaI5","actionContainer":"OrderPopup_actionContainer__2Tc24"};